module.exports = __webpack_public_path__ + "static/img/company-map.7f91914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company-map.png
// module id = xp3D
// module chunks = 1